import { Project } from '@bimone/bimtrack-core';
import type { ProjectDto } from './types';

class ProjectAssembler {
  public toDomain(dto: ProjectDto): Project {
    return new Project({
      id: dto.Id,
      name: dto.Name,
    });
  }
}

export default new ProjectAssembler();
